import { ReactElement } from 'react';

import { WaitlistEntry, WaitlistEntryQuery } from '@dreryk/egabinet-waitlist-frontend-api';
import { PatientSimple, PatientSimpleQuery } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

type WaitlistEntrySectionLoaderRendererProps = {
   readonly entry: WaitlistEntry;
   readonly patient: PatientSimple;
};

type WaitlistEntrySectionLoaderProps = {
   readonly children: (renderProps: WaitlistEntrySectionLoaderRendererProps) => ReactElement;
   readonly entryId: number;
   readonly patientId: number;
};

// eslint-disable-next-line max-lines-per-function
export const WaitlistEntrySectionLoader = (props: WaitlistEntrySectionLoaderProps): ReactElement | null => {
   const { data: entry, loading: entryLoading, error: entryError } = useCqrsGet<WaitlistEntry>(() => {
      const query = new WaitlistEntryQuery();
      query.id = Slot.of(props.entryId);
      return query;
   });

   const { data: patient, loading: patientLoading, error: patientError } = useCqrsGet<PatientSimple>(() => {
      const query = new PatientSimpleQuery();
      query.id = Slot.of(props.patientId);
      return query;
   });

   if (entryLoading || patientLoading) {
      return <LoaderSpinner />;
   }

   if (entryError || patientError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      entry: entry,
      patient: patient,
   });
};
